import { Field } from "@/components/ui/field";
import { InputGroup } from "@/components/ui/input-group";
import { Icon, Input } from "@chakra-ui/react";
import {
  FieldValues,
  Path,
  RegisterOptions,
  UseFormRegister,
} from "react-hook-form";
import { ElementType } from "react";

interface FormInputProps<TFormValues extends FieldValues> {
  name: Path<TFormValues>;
  label: string;
  register: UseFormRegister<TFormValues>;
  error?: { message?: string };
  disabled?: boolean;
  readOnly?: boolean;
  required?: boolean;
  rules?: RegisterOptions<TFormValues, Path<TFormValues>>;
  icon?: ElementType;
  iconColor?: string;
  placeholder?: string;
  autoFocus?: boolean;
  type?: string;
  fontWeight?: string;
}

export const FormInput = <TFormValues extends FieldValues>({
  name,
  label,
  register,
  error,
  disabled = false,
  readOnly = false,
  required = false,
  rules,
  icon,
  iconColor = "blue",
  placeholder = "",
  autoFocus = false,
  type = "text",
  fontWeight,
}: FormInputProps<TFormValues>) => {
  const validationRules: RegisterOptions<TFormValues, Path<TFormValues>> = {
    ...rules,
    required: rules?.required ?? (required ? `${label} ist erforderlich` : false),
  };
  return (
    <Field
      id={name}
      label={label}
      fontWeight={fontWeight}
      required={required}
      disabled={disabled}
      readOnly={readOnly}
      invalid={!!error}
      errorText={error?.message}
    >
      <InputGroup
        w="full"
        startElement={icon ? <Icon as={icon} color={iconColor} /> : undefined}
      >
        <Input
          type={type}
          autoFocus={autoFocus}
          placeholder={placeholder}
          {...register(name, validationRules)}
        />
      </InputGroup>
    </Field>
  );
};
